import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Home from './pages/Home';
import Reports from './pages/Reports';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import UsersPage from './pages/UsersPage';
import Settings from './pages/Settings';
import ResetPassword from './pages/ResetPassword'; // NOVO: Importe a página de redefinição

function App() {
  return (
    <div className="app">
      <Routes>
        <Route path="/login" element={<Login />} />
        {/* NOVO: Rota para a página de redefinição de senha */}
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* Rotas protegidas (exigem autenticação) */}
        <Route path="/" element={<PrivateRoute><Home /></PrivateRoute>} />
        <Route path="/relatorios" element={<AdminRoute><Reports /></AdminRoute>} />
        <Route path="/usuarios" element={<PrivateRoute><UsersPage /></PrivateRoute>} />
        <Route path="/configuracoes" element={<AdminRoute><Settings /></AdminRoute>} />

        {/* Rota curinga para qualquer caminho não encontrado, redireciona para a Home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default App;